import React from 'react';
import VideoSlide from '../../body/VideoSlide';

const BehaviorAgain = () => {
  return <VideoSlide vidSrc={1198766362} />;
};

export default BehaviorAgain;
